<template>
  <div class="page">
    <h2>Account</h2>
    <AccountDetails :account="account"/>

    <!--
    <h2>Backup</h2>
    <button @click="backup">Backup</button>
    -->

    <!--     
    <h2>Restore</h2>
    <div>
      <input id="backupFileInput" type="file" @change="onFileChange"/>
      <button @click="restore">Apply</button>
    </div>
    -->

    <pre class="debug" v-show="debugMode">{{ account }}</pre>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import AccountDetails from '@/components/AccountDetails.vue'

export default {
  name: 'account',
  components: {
    AccountDetails
  },
  computed: {
    ...mapState([
      'debugMode',
      'apiAccount',
      'account'
    ])
  },
  methods: {
    refreshAccount () {
      this.$store.dispatch('loadAccount')
    },
    cancel () {
      this.$store.dispatch('loadAccount')
    },
    save () {
      this.$store.dispatch('saveAccount')
    },
    onFileChange (event) {
      if (event.target.files) {
        this.backupFile = event.target.files[0]
      }
    },
    backup () {
      this.apiAccount.download('/account/backup', this.account.name + '_backup.json')
    },
    restore () {
      if (!this.backupFile) return
      var formData = new FormData()
      formData.set('backup_file', this.backupFile)
      this.apiAccount.post('/account/backup', formData).then( () => {
        alert('Account restored succesfully')
        this.$store.dispatch('loadAccount')
      })
      this.backupFile = null
      document.getElementById('backupFileInput').value = null
    }
  }
}
</script>
